import { computed, inject, Injectable, Signal } from '@angular/core';
import { AddressesRequestService } from './addresses-request.service';
import { DeliveryModeFacade } from '@lentau/delivery-mode/store/delivery-mode.facade';
import { PickupResetService } from '@lentau/delivery-mode/application/pickup-reset.service';
import { AddressesFacade } from '@lentau/delivery-mode/store/addresses.facade';
import { AuthFacade } from '@lentau/auth/store';
import { MissionAddressService } from '@lentau/address/mission-address/application/mission-address.service';
import { SignalMethod, signalMethod } from '@ngrx/signals';
import { MissionAddressMode } from '@lentau/address/mission-address/application/types';
import { MissionAddressModeCacheFacade } from '@lentau/address/mission-address/application/mission-address-mode-cache.facade';
import { AddressesUtmListenerService } from './addresses-utm-listener.service';
import { IsAuthLoggedOut } from './types';

@Injectable({
  providedIn: 'root',
})
export class AddressesBootstrapService {
  private addressRequestService: AddressesRequestService = inject(AddressesRequestService);
  private deliveryModeFacade: DeliveryModeFacade = inject(DeliveryModeFacade);
  private pickupResetService: PickupResetService = inject(PickupResetService);
  private authFacade: AuthFacade = inject(AuthFacade);
  private addressesFacade: AddressesFacade = inject(AddressesFacade);
  private missionAddressService: MissionAddressService = inject(MissionAddressService);
  private missionAddressModeCacheFacade: MissionAddressModeCacheFacade = inject(MissionAddressModeCacheFacade);
  private addressesUtmListenerService: AddressesUtmListenerService = inject(AddressesUtmListenerService);

  private isAuthLoggedOut: Signal<IsAuthLoggedOut> = computed(() => ({
    isAuth: this.authFacade.isAuth(),
    isLoggedOut: this.authFacade.isLoggedOut(),
  }));

  private onLogout: SignalMethod<IsAuthLoggedOut> = signalMethod((combine: IsAuthLoggedOut) => {
    if (combine.isAuth || !combine.isLoggedOut) return;

    this.addressesFacade.resetAll();
    this.deliveryModeFacade.resetAll();
    this.pickupResetService.reset();
  });

  private cacheMissionAddressMode: SignalMethod<MissionAddressMode> = signalMethod((mode: MissionAddressMode) => {
    this.missionAddressModeCacheFacade.updateCache(mode);
  });

  public initAddresses(): void {
    this.cacheMissionAddressMode(this.missionAddressService.fullAddressMode);
    this.onLogout(this.isAuthLoggedOut);

    this.addressRequestService.getAddressesForClient();
    this.addressesUtmListenerService.init();
  }
}
